<template>
  <v-layout wrap align-start v-on:keyup.enter="loadProducts">
    <v-flex xs10 md2>
        <!-- :loading="filters.brand.isLoading"-->
        <!-- v-model="selected.brand" -->
        <!-- :value="selected.brand" -->
      <v-autocomplete
        v-model="stored_brand"
        :items="results.brand"
        :search-input.sync="selected.brand"
        :ripple="false"
        background-color="#282732"
        clearable
        hide-details
        append-icon="expand_more"
        item-text="value"
        item-value="id"
        label="Brand"
        solo
        text
      />
        <!-- @change="$emit('updateByFilters', $event, 'brand')" -->
    </v-flex>
    <v-flex xs10 md2>
      <v-tooltip bottom color="#282732" :disabled="!!selected_client">
        <template v-slot:activator="{ on }">
          <div v-on="on">
              <!-- :loading="filters.category.isLoading" -->
            <v-autocomplete
              v-model="stored_category"
              :items="results.category"
              :search-input.sync="selected.category"
              :ripple="false"
              :disabled="!(!!selected_client)"
              background-color="#282732"
              clearable
              hide-details
              append-icon="expand_more"
              item-text="value"
              item-value="id"
              label="Category"
              solo
              text
            />
              <!-- @change="$emit('updateByFilters', $event, 'category')" -->
          </div>
        </template>
        <span>Please select Client!</span>
      </v-tooltip>
    </v-flex>
    <v-flex xs10 md2>
        <!-- :loading="filters.product.isLoading" -->
        <!-- :search-input.sync="filters.product.search" -->
      <v-autocomplete
        v-model="stored_product"
        :items="results.product"
        :search-input.sync="selected.product"
        :ripple="false"
        background-color="#282732"
        clearable
        hide-details
        append-icon="expand_more"
        item-text="value"
        item-value="id"
        label="Name"
        solo
        text
      />
        <!-- @change="$emit('updateByFilters', $event, 'product')" -->
    </v-flex>
    <v-flex xs10 md2>
      <v-tooltip bottom color="#282732" :disabled="!!selected_client">
        <template v-slot:activator="{ on }">
          <div v-on="on">
              <!-- :loading="filters.sku.isLoading" -->
              <!-- :search-input.sync="filters.sku.search" -->
              <!-- :value="stored_sku" -->
            <v-autocomplete
              v-model="stored_sku"
              :items="results.sku"
              :search-input.sync="selected.sku"
              :ripple="false"
              :disabled="!(!!selected_client)"
              background-color="#282732"
              clearable
              hide-details
              append-icon="expand_more"
              item-text="value"
              item-value="value"
              label="SKU"
              solo
              text
            >
            <!-- for clearable -->
            <!-- <template v-slot:append>
              <v-btn fab small>
                <v-icon>clear</v-icon>
              </v-btn>
            </template> -->
            </v-autocomplete>
              <!-- @change="$emit('updateByFilters', $event, 'sku')" -->
          </div>
        </template>
        <span>Please select Client!</span>
      </v-tooltip>
    </v-flex>
    <v-flex xs10 md2>
        <!-- :loading="filters.ean.isLoading" -->
        <!-- :search-input.sync="filters.ean.search" -->
      <v-autocomplete
        v-model="stored_ean"
        :items="results.ean"
        :search-input.sync="selected.ean"
        :ripple="false"
        background-color="#282732"
        clearable
        hide-details
        append-icon="expand_more"
        item-text="value"
        item-value="id"
        label="EAN"
        solo
        text
      />
        <!-- @change="$emit('updateByFilters', $event, 'ean')" -->
    </v-flex>
    <v-flex xs10 md2>
      <v-btn
        x-large
        :ripple="false"
        color="red darken-4"
        @click="loadProducts"
        class="ex-btn ex-primary-btn ex-fixed-height-btn"
        :disabled="!disable_load_rules"
      >
        load
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
/* eslint-disable */
import { productionBus } from "@/helpers/buses";

export default {
  name: 'N_CharacteristicsFilter',
  data: () => ({
    selected: {
      brand: '',
      category: '',
      product: '',
      sku: '',
      ean: '',
    },
    results: {
      brand: [],
      category: [],
      product: [],
      sku: [],
      ean: [],
    },
  }),
  computed: {
    selected_client () {
      return this.$store.state.productionModule.product_filter.selected_client;
    },
    selected_domains () {
      return this.$store.state.productionModule.product_filter.selected_domains;
    },
    selected_sellers () {
      return this.$store.state.productionModule.product_filter.selected_sellers;
    },
    selected_filter_product_status () {
      return this.$store.state.productionModule.product_filter.product_status;
    },
    loading: {
      get() {
        return this.$store.state.productionModule.loading;
      },
      set(value) {
        const data = { value, key: "loading" };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", data);
      },
    },
    product_status() {
      return this.$store.state.productionModule.product_filter.product_status;
    },
    disable_load() {
      return (!parseInt(this.selected_client) && this.product_status === 'active'); // disable when active products and not selected client
    },
    stored_brand: {
      get() {
        return this.$store.state.productionModule.product_filter.brand
      },
      set( value ) {
        const data = { value , key: 'brand'} ;
        this.$store.commit('productionModule/SET_PRODUCT_FILTER', data )
      }
    },
    stored_category: {
      get() {
        return this.$store.state.productionModule.product_filter.category
      },
      set( value ) {
        const data = { value , key: 'category'} ;
        this.$store.commit('productionModule/SET_PRODUCT_FILTER', data )
      }
    },
    stored_product: {
      get() {
        return this.$store.state.productionModule.product_filter.name
      },
      set( value ) {
        const data = { value , key: 'name'} ;
        this.$store.commit('productionModule/SET_PRODUCT_FILTER', data )
      }
    },
    stored_sku: {
      get() {
        return this.$store.state.productionModule.product_filter.sku
      },
      set( value ) {
        const data = { value , key: 'sku'} ;
        this.$store.commit('productionModule/SET_PRODUCT_FILTER', data  )
      }
    },
    stored_ean: {
      get() {
        return this.$store.state.productionModule.product_filter.ean
      },
      set( value ) {
        const data = { value , key: 'ean'} ;
        this.$store.commit('productionModule/SET_PRODUCT_FILTER', data )
        // const data = { value , key: 'productFilter.sku'} ;
        // this.$store.commit('productionModule/SET_PRODUCTION_STATE', data )
      }
    },
    status() {
      return this.$store.state.productionModule.product_filter.selected_status;
    },
    filter() { return this.$store.state.productionModule.product_filter },
    disable_load_rules() {
      return (this.filter.product_status === 'pending' && this.filter.selected_status != undefined) || this.filter.product_status == 'active'
    },
  },
  methods: {
    // getFilterResult (field, setStore, payload) {
    //   if (this.timer) {
    //     clearTimeout(this.timer)
    //     this.timer = null
    //   }
    //   this.timer = setTimeout(() => {
    //     this.filters[field].isLoading = true
    //     this.$store.dispatch('productModule/getProductFilter', payload)
    //       .then((res) => {
    //         this.$store.commit(`productModule/${setStore}`, res.data)
    //         this.filters[field].isLoading = false
    //       })
    //   }, 200)
    // },
    handleEnter(event) {
      if (event.keyCode === 13) {//enter
        this.loadProducts();
      }
    },
    loadProducts () {
      if (this.$store.state.sidebarModule.isOpen) {
        this.$store.commit('sidebarModule/toggleSidebar')
      }
      const reset_prod = {value: { id : 0, specs: [], status: null }  , key: 'selected_product'}
      this.$store.commit('productionModule/SET_PRODUCTION_STATE', reset_prod )// reset selected product
      this.$store.commit('productionModule/RESET_PRODUCTION');
      const reset_data = { value: [] , key: 'loaded_products'} ;// reset state.loaded_products
      this.$store.commit('productionModule/SET_PRODUCTION_STATE', reset_data )//SET_LOADED_PRODUCTS
      this.loading = true;
      const data = {
        task: 'getProductList',
        payload: {
          filters: {
            brandFilter: this.selected.brand ,
            clientFilter: this.selected_client ,
            domainFilter: this.selected_domains ,
            eanFilter: this.selected.ean ,
            nameFilter: this.selected.product ,
            productStatus: this.selected_filter_product_status ,
            sellerFilter: this.selected_sellers ,
            category: this.selected.category ,
            skuFilter: this.selected.sku ,
            status: this.status ,
            list: this.$store.state.productionModule.product_filter.list,
            product_type: this.$store.state.productionModule.product_filter.product_type,
            dates: this.$store.state.productionModule.product_filter.dates,
          }
        }
      };
      this.$store.dispatch('productionModule/general_api', data )
      .then(res => {
        this.loading = false;
        console.log('check load products - result getProductList', res.data)
        const msg = (res.data.message) ? res.data.message : 'Error on products load ';
        const snackbar = { text: msg }
        if( !Array.isArray(res.data.payload) ){
          Object.assign(snackbar, {color: 'warning'})
          productionBus.$emit('open_snackbar', snackbar )
          return false;
          }
        const data = { value: res.data.payload , key: 'loaded_products'} ;// state.loaded_products = res.data.payload
        this.$store.commit('productionModule/SET_PRODUCTION_STATE', data )//SET_LOADED_PRODUCTS

if(res.data.payload.length === 0) {
          Object.assign(snackbar, {color: 'warning'})
          productionBus.$emit('open_snackbar', snackbar )
          return
        }
        Object.assign(snackbar, {color: 'blue-grey'})
        productionBus.$emit('open_snackbar', snackbar )
        const data2 = { value: res.data.payload[0].product_id , key: 'id' };
        this.$store.commit('productionModule/SET_SELECTED_PRODUCT', data2 );
        //second nested api for the selection of the first item
        const payload = {
            task: "getProducts",
            payload: { product_id: [res.data.payload[0].product_id] },
          }
        if(this.filter.product_status === 'pending')
          payload.payload.list_id = this.filter.list
        this.$store.dispatch("productionModule/general_api", payload).then((res) => {
          const data3 = {
            key: 'specs',
            value: res.data.specs,
          };
          this.$store.commit("productionModule/SET_SELECTED_PRODUCT", data3 )
          this.$store.commit("productionModule/SET_SELECTED_PRODUCT_STATUS", res.data.productStatus)

        });
      }).catch(err => {
        console.log('error', err)
        const snackbar = {
            text: 'Error on load products',
            color: 'error',
          };
        productionBus.$emit('open_snackbar', snackbar )
      })
      if(this.$route.name == "products-configuration"){
        this.$router.push({ name: "products-configuration" });
      } else if (this.$route.name != "product-table") {
        this.$router.push({ name: "product-table" });
      }
      // if(this.$route.name != "production"){
      //   this.$router.push({ name: "production" });
      // } else {
      //   this.$router.push({ name: "product-table" });
      // }
      this.$emit('close_filter_panel')
    },
    get_selected( type, value ) {
      if (!!this.selected_client) {
        const payload = {
          task: 'getProductFilter',
          payload: {
            brand_selection: this.selected.brand ,
            category_selection: this.selected.category ,
            client_selection: this.selected_client ,
            domain_selection: this.selected_domains ,
            ean_selection: this.selected.ean ,
            filterTarget: `${(type == 'product')?'name':type}Filter` ,
            name_selection: this.selected.product ,
            seller_selection: this.selected_sellers ,
            sku_selection: (this.selected.sku !== 0) ? this.selected.sku : "" ,
            product_name: this.selected.product,
            brand_id: this.selected.brand,
            sku: (this.selected.sku !== 0) ? this.selected.sku : "",
          }
        };
        // console.log('payload', payload);
        this.$store.dispatch('productionModule/general_api', payload)
        .then(res => {
          console.log('go for ' + type, res.data)
          this.results[`${type}`] = res.data;
          console.log('done result.'+type, this.results[type])
        })
        // .finally( () => {
        //   const found = this.results[type].find(s => s === value )
        //   if ( !!found ) {
        //     this.selected[type] = found;
        //     this[`stored_${type}`] = found;
        //   }
        // })
      }
    },
  },
  watch: {
    // selected(newSelected, oldSelected) {
    //   console.log('selected.brand old' , oldSelected)
    //   console.log('selected.brand new' , newSelected)
    // }
    'selected.brand'(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected('brand', newValue);
        // this.stored_brand = newValue;
      }
    },
    'selected.category'(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected('category', newValue);
        // this.stored_category = newValue;
      }
    },
    'selected.product'(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected('product', newValue);
        // this.stored_product = newValue;
      }
    },
    'selected.sku'(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected('sku', newValue);
        // this.stored_sku = newValue;
        // const found = this.results.sku.find(s => s === newValue )
        // console.log('found sku ?? ', found)
        // if ( !!found ) {
        //   this.selected.sku = found;
        //   this.stored_sku = found;
        // }
      }
    },
    'selected.ean'(newValue) {
      if (newValue && newValue.length > 2) {
        this.get_selected('ean', newValue);
        // this.stored_ean = newValue;
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleEnter);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEnter);
  }
}

</script>



// WEBPACK FOOTER //
// src/components/production/N_CharacteristicsFilter.vue